import dispatcher from '../dispatcher';
import resizeStore from '../resize/resize.store';

var elementProto = Object.create(HTMLElement.prototype);

var _handleResize = function() {
	var currentOffset = -100;
	var additionalPadding = 0;
	var self = this;
	var padding = 85;
	var lineNum = -1;

	var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

	if (resizeStore.getData().width < 640) {
		padding = 45;
	}

	Array.prototype.forEach.call(this._elements, function(el, index) {
		el.style.width = 'auto';
	});

	Array.prototype.forEach.call(this._elements, function(el, index) {
		function setLastOfLine(lastOfline) {
			var lineFiller;
			var shift, width;

			lineNum++;
			if (!self._fillLines[lineNum]) {
				lineFiller = document.createElement('div');
				lineFiller.classList.add('tag-fill');
				self.appendChild(lineFiller);
				self._fillLines.push(lineFiller);
			} else {
				lineFiller = self._fillLines[lineNum];
			}

			lineFiller.style.opacity = 1;
			lineFiller.style.top = self._lh * lineNum + 'px';
			shift = lastOfline.offsetLeft + lastOfline.clientWidth;
			width = self.clientWidth - shift;
			lineFiller.style.left = shift - 4 + 'px';
			lineFiller.style.width = width + 4 + 'px';
			if (width < 0) {
				lineFiller.style.opacity = 0;
			}
		}

		// function setLastOfLine(lastOfline) {
		// 	lastOfline.style.width = self.clientWidth - lastOfline.offsetLeft - padding - additionalPadding + 'px';
		// 	additionalPadding = 0;
		// }

		if (!isFirefox && self._bg) {
			if (el.offsetTop > currentOffset) {
				currentOffset = el.offsetTop;
				if (self._elements[index - 1]) {
					setLastOfLine(self._elements[index - 1]);
				}
			} else {
				additionalPadding += 1;
			}
			if (index === self._elements.length - 1) {
				additionalPadding = 0;
				setLastOfLine(el);
			}
		}

		if (el.offsetLeft < 10) {
			el.classList.add('first');
		} else {
			el.classList.remove('first');
		}
	});

	self._fillLines = self._fillLines.filter(function(line, index) {
		if (index > lineNum) {
			self.removeChild(line);
		}
		return index <= lineNum;
	});
}

elementProto.createdCallback = function() {
	this.handleResize = _handleResize.bind(this);
	this._fillLines = [];
	this._lh = 53;
}
elementProto.attachedCallback = function() {
	this._elements = this.getElementsByClassName('tag');
	this._bg = this.classList.contains('tag-bg');
	this._fillLines = this.getElementsByClassName('tag-fill');
	this._fillLines = Array.prototype.slice.call(this._fillLines);

	this.handleResize();
	resizeStore.subscribe(this.handleResize);
}
elementProto.detachedCallback = function() {
	resizeStore.unsubscribe(this.handleResize);
}

document.registerElement('tag-wrapper', {
	prototype: elementProto
});